import { CommonModule } from '@angular/common';
import { Component, inject, Injector } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy } from '@ngneat/until-destroy';
import { I18NextPipe } from 'angular-i18next';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';
import { ComputerBackupFacade } from 'mbs-ui-shared@facades/computer.backup.facade';
import { ComputersFacade } from 'mbs-ui-shared@facades/computers.facade';
import Computer, { AgentType, minimalWindowsVersionForOfflineEdit } from 'mbs-ui-shared@models/Computer';
import { filter, switchMap } from 'rxjs/operators';
import { DateTimeFormatComponent } from './date-time-format.component';

@UntilDestroy()
@Component({
  selector: 'mbs-backup-date-time-format',
  templateUrl: './date-time-format.component.html',
  imports: [CommonModule, I18NextPipe, NgbTooltipModule]
})
export class BackupDateTimeFormatComponent extends DateTimeFormatComponent {
  auth: AuthFacade;
  private computersFacade = inject(ComputersFacade);
  private facade = inject(ComputerBackupFacade);
  private injector = inject(Injector);

  constructor() {
    const auth = inject(AuthFacade);

    super();

    this.auth = auth;
  }

  getAgentUtcOffsetValue() {
    return this.computersFacade.getByHid$(this.hid()).pipe(
      filter(Boolean),
      switchMap((computer: Computer) => {
        if (
          computer?.online &&
          Computer.isWindows(computer) &&
          Computer.IsUnsupportedAgentVersion(computer, AgentType.Backup, minimalWindowsVersionForOfflineEdit)
        ) {
          return this.facade.getAgentUtcOffsetValue(computer.hid);
        }

        return toObservable(this.facade.timezoneByHid(computer.hid), { injector: this.injector });
      })
    );
  }
}
